import store from '@/store';

import pureBatchLayoutOperations from './batchLayoutOperations';
import pureHideLayoutComponent from './hideLayoutComponent';
import pureInitLayout from './initLayout';
import pureMergeLayoutProperty from './mergeLayoutProperty';
import pureSetLayoutProperty from './setLayoutProperty';
import pureShowLayoutComponent from './showLayoutComponent';

const withDispatch = pureAction => (context, event, meta) => {
  store.dispatch(pureAction(context, event, meta));
};

export const initLayout = withDispatch(pureInitLayout);
export const setLayoutProperty = withDispatch(pureSetLayoutProperty);
export const mergeLayoutProperty = withDispatch(pureMergeLayoutProperty);
export const showLayoutComponent = withDispatch(pureShowLayoutComponent);
export const hideLayoutComponent = withDispatch(pureHideLayoutComponent);
export const batchLayoutOperations = withDispatch(pureBatchLayoutOperations);
